/**
 * Current terms and privacy-policy versions (§15).
 *
 * A signed-in account is prompted to re-accept when its stored version falls below
 * these. Bump the relevant number when a policy changes — and keep the **server's**
 * copy (`functions/src/shared/config.js` `POLICY_VERSIONS`) in step, since the
 * server validates the version a client claims to have accepted.
 */
export const POLICY_VERSION = Object.freeze({ terms: 2, privacy: 1 });
